import { render, staticRenderFns } from "./koordinator.vue?vue&type=template&id=09a25e51"
import script from "./koordinator.vue?vue&type=script&lang=js"
export * from "./koordinator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports